/*
  The sticky add-to-cart bar.

  Two jobs, and neither of them is adding to the cart - the theme's product form does that.

  1. Decide when the bar is on screen. It appears once the real buy button has scrolled out of
     view and hides again when it comes back, so the two are never both visible arguing about
     the same purchase. With no buy button on the page the bar simply stays.

  2. Stay truthful about what will be bought. The bar mirrors whichever bundle is selected in
     the main section - both the variant it posts and the price it shows. A bar that says $199
     while the page has $358 chosen is worse than no bar at all.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-oralux-sticky-atc]';

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function initOne(bar) {
    if (bar.hasAttribute('data-oralux-ready')) return;
    bar.setAttribute('data-oralux-ready', '');

    var data = {};
    var payload = bar.querySelector('[data-oralux-bar-variants]');
    if (payload) {
      try {
        data = JSON.parse(payload.textContent);
      } catch (e) {
        data = {};
      }
    }

    var idInput = bar.querySelector('input[name="id"]');
    var priceEl = bar.querySelector('[data-oralux-bar-price]');

    function mirror(variantId) {
      if (!variantId) return;
      if (idInput) idInput.value = variantId;

      var variant = data.variants && data.variants[variantId];
      if (variant && priceEl) priceEl.textContent = money(variant.price, data.money_format);
    }

    /*
      Delegated on the document: the selector lives in another section, and binding to the
      inputs directly would miss any the theme re-renders on a variant change.
    */
    document.addEventListener('change', function (event) {
      var input = event.target.closest('input[name="id"]');
      if (!input || bar.contains(input)) return;
      mirror(input.value);
    });

    var chosen = document.querySelector('[data-oralux-buy] input[name="id"]:checked');
    if (chosen) mirror(chosen.value);

    /* Reveal */

    var watchSelector = bar.getAttribute('data-oralux-watch');
    var watched = watchSelector ? document.querySelector(watchSelector) : null;

    if (!watched || !('IntersectionObserver' in window)) {
      bar.setAttribute('data-shown', '');
      return;
    }

    /*
      A scroll listener rather than an IntersectionObserver, and deliberately so. The observer
      only reports threshold crossings: jump the page from above the buy button to below it -
      an anchor, the End key, a restored scroll position - and the element goes from
      not-intersecting straight back to not-intersecting, so nothing fires and the bar never
      appears. Measured: it stayed hidden after a jump past the button.

      The listener is passive and throttled to one frame, and reads a single rect.
    */
    var ticking = false;

    function evaluate() {
      ticking = false;
      bar.toggleAttribute('data-shown', watched.getBoundingClientRect().bottom < 0);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
